export enum MimeType {
  JPG = 'JPG',
  GIF = 'GIF',
  PDF = 'PDF',
  XLS = 'XLS',
  XLSX = 'XLSX',
}

export const ALLOWED_UPLOAD_MIME_TYPES: Record<MimeType, string> = {
  [MimeType.PDF]: 'application/pdf',
  [MimeType.XLS]: 'application/vnd.ms-excel',
  [MimeType.XLSX]: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  [MimeType.GIF]: 'image/gif',
  [MimeType.JPG]: 'image/jpeg',
};

export function getMimeTypesArr(types: MimeType[]) {
  return types.map((type) => ALLOWED_UPLOAD_MIME_TYPES[type]);
}

export function getMimeTypesList(types: MimeType[]) {
  return getMimeTypesArr(types).join(',');
}